import React, { useCallback, useContext } from 'react';
import { ReportsContainerContext, IReportsContainerContext } from '../reportsContainerState/reportsContainerContext';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<IReportsContainerContext>(ReportsContainerContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'deletionError'}
				description="errorDeletingReports"
			/>
		</div>
	);
};

export default React.memo(ModalWindows);
